export default {

  setup() {

    console.log('Maps are set up');

    const mapBox = document.getElementById("map");

    if(mapBox){

      console.log('Maps here');
      mapboxgl.accessToken = 'pk.eyJ1IjoibWlrZWhhcnJpc29uIiwiYSI6ImNsdzNpbHV3ODBxOTcyanBoY2FjdDg2b3MifQ.0hNfC-Cr4X3s6zlOdFqwLg';

      const lat = mapBox.dataset.lat;
      const lon = mapBox.dataset.lon;

      const map = new mapboxgl.Map({
        container: 'map', // container ID
        style: 'mapbox://styles/mapbox/streets-v12?optimize=true', // style URL
        center: [lon, lat], // starting position [lng, lat]
        zoom: 13, // starting zoom
        cooperativeGestures: true,
      });

      const marker1 = new mapboxgl.Marker({ color: '#16273F'})
        .setLngLat([lon, lat])
        .addTo(map);

  }

  },
  destroy() {

  },
}